import { BaseActionEnum } from "../../components/action-menu/ActionMenuItem";
import { getActionMenuItems } from "../../components/action-menu/BaseActions";

const actionEnums = [
     BaseActionEnum.Export,
     BaseActionEnum.Refresh,
     BaseActionEnum.Favorite
];

export const actionItems = getActionMenuItems(actionEnums);        
